export default {"src":"/_next/static/media/va.249f9af5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};